import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Card, CardContent, CardMedia, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { AppRoutes } from 'types';

type ActivityLink = {
  description: string;
  route: string;
  src: string;
  title: string;
  letter: string;
};

const ActivityLink: React.FC<ActivityLink> = ({ description, route, src, title, letter }) => {
  const classes = styles();
  return (
    <Grid className={classes.gridItem} item>
      <Link
        to={{ pathname: route }}
        state={{ backRoute: `/${AppRoutes.ACTIVITY_SELECTION}/${letter}` }}
        className={classes.link}
      >
        <Card className={classes.card} elevation={4}>
          <CardMedia className={classes.media} image={src} title={title} />
          <CardContent className={classes.content}>
            <Typography component="h2" variant="h5">
              {title}
            </Typography>
            <Typography color="textPrimary" component="p" variant="subtitle1">
              {description}
            </Typography>
          </CardContent>
        </Card>
      </Link>
    </Grid>
  );
};

const styles = makeStyles((theme: any) => ({
  card: {
    padding: theme.spacing(6),
    width: remCalc(276),
    maxWidth: remCalc(276),
    height: '100%',
    boxSizing: 'border-box',
  },
  gridItem: {
    textAlign: 'left',
  },
  link: {
    textDecoration: 'none',
  },
  media: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '5px',
    height: remCalc(240),
  },
  content: {
    padding: `${theme.spacing(3)} 0 0 0`,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
}));

export default ActivityLink;
